import { CheckIcon } from "@ui/components/internal/CheckIcon";
import {
  createTileSelectionGroup,
  type TileSelectionItemProps,
} from "@ui/components/internal/TileSelectionGroup/createTileSelectionGroup";
import type { TileVariants } from "@ui/components/Tile/styles";
import {
  CheckboxGroup as BaseCheckboxGroup,
  type CheckboxGroupProps as BaseCheckboxGroupProps,
  Checkbox,
} from "@ui/primitives/CheckboxGroup";
import { cx } from "@ui/utils/cx";
import type { ReactNode } from "react";

export interface TileCheckboxGroupProps extends BaseCheckboxGroupProps {
  children: ReactNode;
  color?: TileVariants["color"];
  control?: TileVariants["control"];
  hierarchy?: TileVariants["hierarchy"];
  shape?: TileVariants["shape"];
  size?: TileVariants["size"];
  align?: "vertical" | "horizontal";
}

export interface TileCheckboxGroupItemProps extends TileSelectionItemProps {}

export const TileCheckboxGroup: ((props: TileCheckboxGroupProps) => ReactNode) & {
  Item: (props: TileCheckboxGroupItemProps) => ReactNode;
} = createTileSelectionGroup<BaseCheckboxGroupProps>({
  Group: BaseCheckboxGroup,
  Item: Checkbox,
  defaultControl: "checkbox",
  renderIndicatorContent: ({ isDisabled, isSelected }) => (
    <CheckIcon
      className={cx(
        "pointer-events-none size-3 text-white opacity-0 transition-inherit-all",
        isSelected && "opacity-100",
        isDisabled && "text-fg-disabled_subtle",
      )}
    />
  ),
});
